module.exports = __webpack_public_path__ + "static/media/timesRomanBold.d3ab9493.ttf";